import * as React from "react";
const SvgFiRrInvite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-invite_svg__a)">
      <path
        fill="#062147"
        d="M1 15.5C1 17.43 2.57 19 4.5 19S8 17.43 8 15.5 6.43 12 4.5 12 1 13.57 1 15.5m5 0c0 .827-.673 1.5-1.5 1.5S3 16.327 3 15.5 3.673 14 4.5 14s1.5.673 1.5 1.5M19.5 12c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 5c-.828 0-1.5-.673-1.5-1.5s.672-1.5 1.5-1.5c.826 0 1.5.673 1.5 1.5s-.674 1.5-1.5 1.5M14 23a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1M1 11a1 1 0 0 0 1-1h20a1 1 0 1 0 2 0V7c0-2.757-2.244-5-5-5h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 1 0-2 0v1H5C2.243 2 0 4.243 0 7v3a1 1 0 0 0 1 1m4-7h14c1.654 0 3 1.346 3 3v1H2V7c0-1.654 1.346-3 3-3m3.885 18.535a1 1 0 1 1-1.77.931c-.47-.89-1.495-1.465-2.615-1.465s-2.146.575-2.615 1.465a1 1 0 1 1-1.77-.931C.937 20.972 2.617 20 4.5 20s3.562.971 4.385 2.535m14.58 1.351a1 1 0 0 1-1.351-.42c-.469-.89-1.495-1.465-2.614-1.465-1.12 0-2.146.575-2.616 1.465a1 1 0 1 1-1.77-.931C15.936 20.972 17.617 20 19.5 20c1.883 0 3.561.971 4.384 2.535a1 1 0 0 1-.419 1.351"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-invite_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInvite;
